import { useEffect, useState } from 'react';
import router from 'next/router';

export default function useIsEdit() {
    const { returnUrl, openStep, brief } = router.query || undefined;
    const [url, setUrl] = useState('');
    const [step, setStep] = useState<number>(0);

    useEffect(() => {
        if (returnUrl) {
            setUrl(`${returnUrl}`);
        } else {
            setUrl('');
        }

        if (openStep) {
            setStep(Number(openStep));
        } else {
            setStep(0);
        }
    }, [returnUrl, openStep]);

    return { url, step, briefIndex: brief };
}
